<template>
<div class="chapter">
<div class="inner_page">
<a id="Page-1"></a>
<p class="Chap_head_f">LAST YEARS OF THE</p>
<p class="Chap_head_t">LONDON</p>
<p class="Chap_head2">TITAN</p>
<a id="Page-2"></a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 001_Half_title_page.vue?30244aad